<dackl-explicit-search class="h-15 flex flex-row items-center"
  size="large"
  placeholder="{{ 'search-slot.search_placeholder' | translate }}"
  (input)="onSearchTermChange($event)"
  (searchButtonPressed)="search()" (keydown.shift.enter)="search()"
  (clearButtonPressed)="clear()">
</dackl-explicit-search>
